module.exports = __webpack_public_path__ + "img/23_64.d42afcb2.png";